const Common = [
        {
            "id": 1,
            "word": "presence",
            "pronunciation": "/ˈpɹɛzəns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 2,
            "word": "recognize",
            "pronunciation": "/ˈɹɛkənaɪz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 3,
            "word": "surely",
            "pronunciation": "/ˈʃɔːli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 4,
            "word": "pleasant",
            "pronunciation": "/ˈplɛzənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 5,
            "word": "citizen",
            "pronunciation": "/ˈsɪtɪzən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 6,
            "word": "mysterious",
            "pronunciation": "/mɪˈstɪəɹi.əs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 7,
            "word": "guarantee",
            "pronunciation": "/ˌɡæɹənˈtiː/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 8,
            "word": "library",
            "pronunciation": "/ˈlaɪbɹi/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 9,
            "word": "cemetery",
            "pronunciation": "/ˈsem.ɘˌtiɘɹ.i/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 10,
            "word": "generally",
            "pronunciation": "/d͡ʒɛn.əɹ.ə.li/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 11,
            "word": "business",
            "pronunciation": "/ˈbɪd.nəs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 12,
            "word": "miniature",
            "pronunciation": "/ˈmɪn(ɪ)ətʃə(ɹ)/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 13,
            "word": "desperate",
            "pronunciation": "/ˈdɛsp(ə)ɹət/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 14,
            "word": "independent",
            "pronunciation": "/ɪndɪˈpɛndənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 15,
            "word": "probably",
            "pronunciation": "/ˈpɹɒbli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 16,
            "word": "possible",
            "pronunciation": "/ˈpɒsɪbl̩/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 17,
            "word": "sincerely",
            "pronunciation": "/sɪnˈsɪəli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 18,
            "word": "address",
            "pronunciation": "/æˈdɹɛs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 19,
            "word": "either",
            "pronunciation": "/ˈaɪð.ə(ɹ)/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 20,
            "word": "ought",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 21,
            "word": "safety",
            "pronunciation": "/ˈseɪfti/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 22,
            "word": "practical",
            "pronunciation": "/ˈpɹæktɪkəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 23,
            "word": "humorous",
            "pronunciation": "/ˈhjuːməɹəs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 24,
            "word": "scissors",
            "pronunciation": "/ˈsɪzəz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 25,
            "word": "irritable",
            "pronunciation": "/ˈɪɹɪtəbl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 26,
            "word": "dilemma",
            "pronunciation": "/daɪˈlɛmə/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 27,
            "word": "before",
            "pronunciation": "/bɪˈfɔː/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 28,
            "word": "forward",
            "pronunciation": "/ˈfoːwəd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 29,
            "word": "believe",
            "pronunciation": "/bɪˈliːv/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 30,
            "word": "interesting",
            "pronunciation": "/ˈɪnt(ə)ɹɛstɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 31,
            "word": "deposit",
            "pronunciation": "/dɪˈpɒzɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 32,
            "word": "category",
            "pronunciation": "/ˈkætəˌɡɔɹi/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 33,
            "word": "coming",
            "pronunciation": "/ˈkʌmɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 34,
            "word": "stopping",
            "pronunciation": "/ˈstɒpɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 35,
            "word": "religious",
            "pronunciation": "/ɹɪ.ˈlɪ.d͡ʒəs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 36,
            "word": "invitation",
            "pronunciation": "/ɪn.vɪˈteɪ.ʃn̩/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 37,
            "word": "strength",
            "pronunciation": "/stɹɛŋkθ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 38,
            "word": "accommodate",
            "pronunciation": "/əˈkɒməˌdeɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 39,
            "word": "exercise",
            "pronunciation": "/ˈɛk.sə.saɪz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 40,
            "word": "writing",
            "pronunciation": "/ˈɹaɪtɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 41,
            "word": "length",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 42,
            "word": "during",
            "pronunciation": "/ˈdjɔː.ɹɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 43,
            "word": "criticize",
            "pronunciation": "/ˈkɹɪtɪsaɪz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 44,
            "word": "heroes",
            "pronunciation": "/ˈhɪəɹəʊz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 45,
            "word": "weather",
            "pronunciation": "/ˈwɛðə/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 46,
            "word": "expect",
            "pronunciation": "/ɛkˈspɛkt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 47,
            "word": "eight",
            "pronunciation": "/eɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 48,
            "word": "toward",
            "pronunciation": "/tɘ.ˈwoːd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 49,
            "word": "truly",
            "pronunciation": "/ˈtɹuːli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 50,
            "word": "particularly",
            "pronunciation": "/pəˈtɪkjəli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 51,
            "word": "recommend",
            "pronunciation": "/ɹɛkəˈmɛnd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 52,
            "word": "across",
            "pronunciation": "/əˈkɹɑs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 53,
            "word": "piece",
            "pronunciation": "/piːs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 54,
            "word": "embarrass",
            "pronunciation": "/ɪmˈbæ.ɹəs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 55,
            "word": "omission",
            "pronunciation": "/oʊˈmɪʃən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 56,
            "word": "naturally",
            "pronunciation": "/ˈnætʃ(ə)ɹəli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 57,
            "word": "shining",
            "pronunciation": "/ˈʃaɪnɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 58,
            "word": "marriage",
            "pronunciation": "/ˈmæɹɪdʒ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 59,
            "word": "imaginary",
            "pronunciation": "/ɪˈmædʒɪn(ə)ɹi/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 60,
            "word": "psychology",
            "pronunciation": "/saɪˈkɒlədʒɪ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 61,
            "word": "unusual",
            "pronunciation": "/ʌnˈjuːʒuəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 62,
            "word": "temporary",
            "pronunciation": "/ˈtɛmpəɹi/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 63,
            "word": "official",
            "pronunciation": "/əˈfɪʃəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 64,
            "word": "interpretation",
            "pronunciation": "/ɪntəpɹəˈteɪʃən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 65,
            "word": "judgment",
            "pronunciation": "/ˈdʒʌdʒ.mənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 66,
            "word": "quarter",
            "pronunciation": "/ˈkoː.tɘ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 67,
            "word": "definite",
            "pronunciation": "/ˈdɛfɪnɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 68,
            "word": "friend",
            "pronunciation": "/fɹɛnd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 69,
            "word": "develop",
            "pronunciation": "/dɛˈvɛ.ləp/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 70,
            "word": "repetition",
            "pronunciation": "/ɹɛpəˈtɪʃən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 71,
            "word": "receive",
            "pronunciation": "/ɹɪˈsiːv/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 72,
            "word": "soldier",
            "pronunciation": "/ˈsɒld͡ʒə/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 73,
            "word": "balance",
            "pronunciation": "/ˈbæləns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 74,
            "word": "proof",
            "pronunciation": "/pɹʉːf/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 75,
            "word": "basically",
            "pronunciation": "/ˈbeɪsɪk(ə)li/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 76,
            "word": "fascinating",
            "pronunciation": "/ˈfæsɪˌneɪtɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 77,
            "word": "surprise",
            "pronunciation": "/səˈpɹaɪz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 78,
            "word": "foreign",
            "pronunciation": "/ˈfɒɹən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 79,
            "word": "ceiling",
            "pronunciation": "/ˈsiːlɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 80,
            "word": "privilege",
            "pronunciation": "/ˈpɹɪv(ɪ)lɪdʒ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 81,
            "word": "neighbor",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 82,
            "word": "rhythm",
            "pronunciation": "/ˈɹɪ.ð(ə)m/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 83,
            "word": "often",
            "pronunciation": "/ˈɑf(t)ən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 84,
            "word": "competition",
            "pronunciation": "/ˌkɒmpəˈtɪʃən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 85,
            "word": "lying, laying",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 86,
            "word": "achieve",
            "pronunciation": "/əˈtʃiːv/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 87,
            "word": "lesson",
            "pronunciation": "/ˈlɛsn̩/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 88,
            "word": "twelfth",
            "pronunciation": "/twɛlfθ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 89,
            "word": "beginning",
            "pronunciation": "/bɪˈɡɪn.ɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 90,
            "word": "until",
            "pronunciation": "/ənˈtɪl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 91,
            "word": "license",
            "pronunciation": "/ˈlaɪsəns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 92,
            "word": "immediately",
            "pronunciation": "/əˈmiːdi.ətli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 93,
            "word": "equipped",
            "pronunciation": "/ɪˈkwɪpt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 94,
            "word": "perform",
            "pronunciation": "/pəˈfɔːm/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 95,
            "word": "grammar",
            "pronunciation": "/ˈɡɹæm.ə(ɹ)/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 96,
            "word": "quite",
            "pronunciation": "/kwaɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 97,
            "word": "quit",
            "pronunciation": "/kwɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 98,
            "word": "identity",
            "pronunciation": "/aɪˈdɛntəti/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 99,
            "word": "loneliness",
            "pronunciation": "/ˈloʊnlinəs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 100,
            "word": "village",
            "pronunciation": "/ˈvɪlɪd͡ʒ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 101,
            "word": "difference",
            "pronunciation": "/ˈdɪfəɹən(t)s/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 102,
            "word": "minute",
            "pronunciation": "/ˈmɪnɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 103,
            "word": "benefit",
            "pronunciation": "/ˈbɛn.ɪ.fɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 104,
            "word": "tries",
            "pronunciation": "/tɹaɪz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 105,
            "word": "sacrifice",
            "pronunciation": "/ˈsækɹɪfaɪs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 106,
            "word": "picture",
            "pronunciation": "/ˈpɪktʃə/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 107,
            "word": "convenience",
            "pronunciation": "/kənˈviːnɪəns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 108,
            "word": "government",
            "pronunciation": "/ˈɡʌvə(n)mənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 109,
            "word": "does",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 110,
            "word": "necessary",
            "pronunciation": "/ˈnɛsəsɹɪ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 111,
            "word": "advertise",
            "pronunciation": "/ˈadvə(ɹ)taɪz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 112,
            "word": "jealous",
            "pronunciation": "/ˈdʒɛləs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 113,
            "word": "succeed",
            "pronunciation": "/səkˈsiːd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 114,
            "word": "persuade",
            "pronunciation": "/pəˈsweɪd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 115,
            "word": "planning",
            "pronunciation": "/ˈplænɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 116,
            "word": "paid",
            "pronunciation": "/ˈpeɪd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 117,
            "word": "careful",
            "pronunciation": "/ˈkɛːfəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 118,
            "word": "guidance",
            "pronunciation": "/ˈɡaɪdəns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 119,
            "word": "realize",
            "pronunciation": "/ˈɹɪə.laɪz/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 120,
            "word": "brilliant",
            "pronunciation": "/ˈbɹɪljənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 121,
            "word": "awful",
            "pronunciation": "/ˈɔːfəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 122,
            "word": "restaurant",
            "pronunciation": "/ˈɹɛs.t(ə).ɹ(ə)nt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 123,
            "word": "experience",
            "pronunciation": "/ɪkˈspɪə.ɹɪəns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 124,
            "word": "disappoint",
            "pronunciation": "/dɪsəˈpɔɪnt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 125,
            "word": "athlete",
            "pronunciation": "/ˈæθ.lit/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 126,
            "word": "prejudice",
            "pronunciation": "/ˈpɹɛd͡ʒədɪs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 127,
            "word": "losing",
            "pronunciation": "/ˈluːzɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 128,
            "word": "intelligent",
            "pronunciation": "/ɪnˈtɛlɪd͡ʒənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 129,
            "word": "parallel",
            "pronunciation": "/ˈpæɹəˌlɛl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 130,
            "word": "Whether",
            "pronunciation": "/ˈwɛðə(ɹ)/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 131,
            "word": "discipline",
            "pronunciation": "/ˈdɪ.sə.plɪn/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 132,
            "word": "occasion",
            "pronunciation": "/əˈkeɪʒən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 133,
            "word": "breathe",
            "pronunciation": "/bɹiːð/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 134,
            "word": "personally",
            "pronunciation": "/ˈpɜːsnəli/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 135,
            "word": "quantity",
            "pronunciation": "/ˈkwɑndədi/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 136,
            "word": "excellent",
            "pronunciation": "/ˈɛksələnt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 137,
            "word": "imitation",
            "pronunciation": "/ɪmɪˈteɪʃən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 138,
            "word": "operate",
            "pronunciation": "/ˈɒpəɹeɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 139,
            "word": "optimism",
            "pronunciation": "/ˈɒptɪmɪzəm/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 140,
            "word": "ridiculous",
            "pronunciation": "/ɹiːˈdɪkjʊləs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 141,
            "word": "explanation",
            "pronunciation": "/ˌɛkspləˈneɪʃən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 142,
            "word": "successful",
            "pronunciation": "/səkˈsɛsfl̩/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 143,
            "word": "neither",
            "pronunciation": "/ˈnaɪð.ə(ɹ)/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 144,
            "word": "existence",
            "pronunciation": "/ɛɡ.ˈzɪs.təns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 145,
            "word": "irrelevant",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 146,
            "word": "laboratory",
            "pronunciation": "/ləˈbɔɹətɹi/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 147,
            "word": "becoming",
            "pronunciation": "/bɪˈkʊmɪŋɡ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 148,
            "word": "separate",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 149,
            "word": "finally",
            "pronunciation": "/ˈfaɪ.nəl.i/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 150,
            "word": "permanent",
            "pronunciation": "/ˈpɜːmənənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 151,
            "word": "through",
            "pronunciation": "/θɹuː/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 152,
            "word": "welcome",
            "pronunciation": "/ˈwɛlkəm/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 153,
            "word": "usually",
            "pronunciation": "/ˈjuːʒju(ə)li/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 154,
            "word": "perceive",
            "pronunciation": "/pəˈsiːv/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 155,
            "word": "among",
            "pronunciation": "/əˈmɒŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 156,
            "word": "speech",
            "pronunciation": "/ˈspiːtʃ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 157,
            "word": "prefer",
            "pronunciation": "/pɹɪˈfɜː/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 158,
            "word": "incidentally",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 159,
            "word": "happiness",
            "pronunciation": "/ˈhæpinəs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 160,
            "word": "island",
            "pronunciation": "/ˈaɪ̯lənd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 161,
            "word": "possess",
            "pronunciation": "/pəˈzɛs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 162,
            "word": "political",
            "pronunciation": "/pəˈlɪtɪkəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 163,
            "word": "mathematics",
            "pronunciation": "/mæθ(ə)ˈmætɪks/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 164,
            "word": "medicine",
            "pronunciation": "/ˈmed(ɪ).sn̩/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 165,
            "word": "experiment",
            "pronunciation": "/ɛk.ˈspɛ.ɹɪ.mənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 166,
            "word": "occurred",
            "pronunciation": "/əˈkɜːd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 167,
            "word": "apparent",
            "pronunciation": "/əˈpæ.ɹənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 168,
            "word": "disappear",
            "pronunciation": "/dɪsəˈpiːɹ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 169,
            "word": "quiet",
            "pronunciation": "/ˈkwaɪ.ət/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 170,
            "word": "secretary",
            "pronunciation": "/ˈsɛk.ɹə.tɹi/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 171,
            "word": "original",
            "pronunciation": "/əˈɹɪdʒnəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 172,
            "word": "professional",
            "pronunciation": "/pɹəˈfɛʃənəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 173,
            "word": "interfere",
            "pronunciation": "/ˌɪntəˈfɪə/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 174,
            "word": "fundamental",
            "pronunciation": "/ˌfʌndəˈmɛntəl/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 175,
            "word": "exaggerate",
            "pronunciation": "/ɛɡˈzæ.dʒə.ɹeɪt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 176,
            "word": "decide",
            "pronunciation": "/dɪˈsaɪd/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 177,
            "word": "persevere",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 178,
            "word": "easily",
            "pronunciation": "/ˈiː.zə.liː/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 179,
            "word": "studying",
            "pronunciation": "/ˈstʌdiːɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 180,
            "word": "promise",
            "pronunciation": "/ˈpɹɒmɪs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 181,
            "word": "certain",
            "pronunciation": "/ˈsɝtn̩/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 182,
            "word": "argument",
            "pronunciation": "/ˈɑːɡjʊmənt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 183,
            "word": "environment",
            "pronunciation": "/-mɪnt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 184,
            "word": "temperature",
            "pronunciation": "/ˈtɛmp(ə)ɹətʃə(ɹ)/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 185,
            "word": "familiar",
            "pronunciation": "/fəˈmɪl.i.ə/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 186,
            "word": "peculiar",
            "pronunciation": "[pʰə̥ˈkʰj̊uːljʊə]",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 187,
            "word": "chief",
            "pronunciation": "/tʃiːf/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 188,
            "word": "calendar",
            "pronunciation": "/ˈkæl.ən.də/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 189,
            "word": "noticeable",
            "pronunciation": "/ˈnəʊtɪsəbl̩/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 190,
            "word": "interruption",
            "pronunciation": "/ˌɪntəˈɹʌpʃən/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 191,
            "word": "acquire",
            "pronunciation": "/əˈkwaɪə/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 192,
            "word": "advice",
            "pronunciation": "/ədˈvaɪs/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 193,
            "word": "except",
            "pronunciation": "/ɪkˈsɛpt/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 194,
            "word": "using",
            "pronunciation": "/ˈjuːzɪŋ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 195,
            "word": "knowledge",
            "pronunciation": "/ˈnɒlɪdʒ/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 196,
            "word": "forty",
            "pronunciation": "/ˈfɔɹti/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 197,
            "word": "reference",
            "pronunciation": "/ˈɹɛf.(ə)ɹəns/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 198,
            "word": "describe",
            "pronunciation": "/dəˈskɹaɪb/",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 199,
            "word": "weird",
            "pronunciation": "x",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 200,
            "word": "similar",
            "pronunciation": "/ˈsɪmələ/",
            "progress": [
                0,
                0,
                0
            ]
        }
    ];
  export default Common;







